import React, { useEffect, useState } from 'react';
import HeaderWithActions from '../../../../../../../../../../lib/designSystem/HeaderWithActions';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@mui/material';
import {
  getShortString,
  loggerDev,
  showAlert,
} from '../../../../../../../../../../lib/functions/utils';
import CustomButton from '../../../../../../../../../../lib/designSystem/Button';
import EnhancedTable from '../../../../../../../../../../lib/designSystem/Table';
import { getManagementsByBusiness } from '../../../../../../../../../../lib/api/collections';
import { deleteCollectionManagementById } from '../../../../../../../../../../lib/api';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../lib/designSystem/CircularProgress';
import dayjs from 'dayjs';
import EditManagement from '../../../Created/components/EditManagement';
import RescheduleManagement from '../../../Created/components/ReSchedule';
import ConfirmAndExecuteDialog from '../../../../../../../../../../lib/designSystem/ConfrimAndExecuteDialog';
import MultiComplete from './components/MultiComplete';
import MultiDelete from './components/MultiDelete';
import MultiReschedule from './components/MultiReschedule';
interface ManagementsDetailsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  business: {
    identifier: string;
    name: string;
  };
  byStakeholder: boolean;
  handleOpenCreateNewManagementFromCompletion: (documentId: string) => void;
  handleOpenCreateNewMultiManagementFromCompletion: (
    documentIds: string[],
  ) => void;
  reloadPage: () => void;
}

const ManagementsDetails = (props: ManagementsDetailsProps) => {
  const {
    open,
    setOpen,
    business,
    byStakeholder,
    handleOpenCreateNewManagementFromCompletion,
    handleOpenCreateNewMultiManagementFromCompletion,
    reloadPage,
  } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [managements, setManagements] = useState([]);

  const [openEditManagement, setOpenEditManagement] = useState(false);
  const [description, setDescription] = useState('');
  const [possiblePaymentDate, setPossiblePaymentDate] = useState('');

  const [rescheduleManagementOpen, setRescheduleManagementOpen] =
    useState(false);
  const [openEditManagementId, setOpenEditManagementId] = useState(0);
  const [dueDate, setDueDate] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogTitle, setConfirmDialogTitle] = useState('');
  const [confirmDialogDescription, setConfirmDialogDescription] = useState('');
  const [confirmAction, setConfirmAction] = useState<() => Promise<void>>(
    () => Promise.resolve,
  );
  const [buttonColor, setButtonColor] = useState<
    'primary' | 'error' | 'warning'
  >('primary');

  const [selectedManagements, setSelectedManagements] = useState<any[]>([]);

  const [openMultiComplete, setOpenMultiComplete] = useState(false);
  const [managementsToComplete, setManagementsToComplete] = useState<any[]>([]);

  const [openMultiDelete, setOpenMultiDelete] = useState(false);
  const [managementsToDelete, setManagementsToDelete] = useState<any[]>([]);

  const [openMultiReschedule, setOpenMultiReschedule] = useState(false);
  const [managementsToReschedule, setManagementsToReschedule] = useState<any[]>(
    [],
  );

  const setUp = async () => {
    setLoading(true);
    try {
      const response = await getManagementsByBusiness(
        dispatch,
        business.identifier,
      );
      setManagements(response);
    } catch (error) {
      loggerDev(error);
    }
    setLoading(false);
  };

  const handleDelete = async (id: number) => {
    if (!id) return;

    setLoading(true);
    try {
      await deleteCollectionManagementById(dispatch, id);
      showAlert(dispatch, 'success', 'Gestión eliminada');
      window.location.reload();
    } catch (error) {
      loggerDev(error);
      showAlert(dispatch, 'error', 'Error al eliminar la gestión');
    }
    setLoading(false);
  };

  const handleConfirmDeleteDialog = (id: number) => {
    setConfirmDialogTitle('Eliminar gestión ' + `#${id}`);
    setConfirmDialogDescription(
      '¿Estás seguro de que deseas eliminar la gestión?',
    );
    setConfirmAction(() => async () => await handleDelete(id)); // Corregido
    setButtonColor('error');
    setConfirmDialogOpen(true);
  };

  const handleComplete = async (id: number) => {
    const management: any = managements.find(
      (management: any) => management.id === id,
    );
    setOpenEditManagement(true);
    setOpenEditManagementId(id);
    setDescription(management.description);
    if (management.possiblePaymentDate) {
      const possiblePaymentDate = new Date(management.possiblePaymentDate);
      setPossiblePaymentDate(dayjs(possiblePaymentDate).format('YYYY-MM-DD'));
    } else {
      setPossiblePaymentDate('');
    }
  };

  const handleReschedule = (id: number) => {
    setRescheduleManagementOpen(true);
    const management: any = managements.find(
      (management: any) => management.id === id,
    );
    if (!management) return;
    const dueDate = new Date(management.dueDate);
    setOpenEditManagementId(id);
    if (dueDate) {
      dueDate.setUTCHours(11, 59, 59, 999);
      setDueDate(dayjs(dueDate).format('YYYY-MM-DD'));
    } else {
      setDueDate('');
    }
  };

  const handleMultiComplete = () => {
    const managementsFound = managements.filter((management: any) =>
      selectedManagements.includes(management.id),
    );
    setManagementsToComplete(managementsFound);
    setOpenMultiComplete(true);
  };

  const handleMultiDelete = () => {
    const managementsFound = managements.filter((management: any) =>
      selectedManagements.includes(management.id),
    );
    setManagementsToDelete(managementsFound);
    setOpenMultiDelete(true);
  };

  const handleMultiReschedule = () => {
    const managementsFound = managements.filter((management: any) =>
      selectedManagements.includes(management.id),
    );
    setManagementsToReschedule(managementsFound);
    setOpenMultiReschedule(true);
  };

  const actions = [
    {
      action: handleConfirmDeleteDialog,
      actionLabel: 'Eliminar',
    },
    {
      action: handleComplete,
      actionLabel: 'Completar',
    },
    {
      action: handleReschedule,
      actionLabel: 'Reprogramar',
    },
  ];

  useEffect(() => {
    setUp();
  }, []);

  return (
    <div>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl">
        <DialogTitle>
          {byStakeholder
            ? `Gestiones del deudor ${getShortString(business.name)} (${business.identifier})`
            : `Gestiones del cliente ${getShortString(business.name)} (${business.identifier})`}
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div style={{ minHeight: '200px' }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          ) : (
            <div style={{ marginTop: '20px' }}>
              <HeaderWithActions
                title="Gestiones pendientes"
                variant={'body1'}
                buttons={[
                  {
                    name: 'Eliminar',
                    color: 'error',
                    disabled: selectedManagements.length === 0,
                    action: handleMultiDelete,
                  },
                  {
                    name: 'Reprogramar',
                    color: 'warning',
                    disabled: selectedManagements.length === 0,
                    action: handleMultiReschedule,
                  },
                  {
                    name: 'Completar',
                    color: 'success',
                    disabled: selectedManagements.length === 0,
                    action: handleMultiComplete,
                  },
                ]}
              />
              <EnhancedTable
                dataHeaders={[
                  { key: 'id', label: 'ID', type: 'numeric-id' },
                  {
                    key: 'elementType',
                    label: 'Tipo',
                    type: 'collection-type',
                  },
                  { key: 'description', label: 'Descripción' },
                  { key: 'folio', label: 'Documento' },
                  {
                    key: 'businessName',
                    label: 'Cliente',
                  },
                  {
                    key: 'stakeholderName',
                    label: 'Deudor',
                  },
                  { key: 'dueDate', label: 'Fecha gestión', type: 'due-date' },
                ]}
                data={managements}
                actions={actions}
                showActions={true}
                rowsPerPageDefault={10}
                selected={selectedManagements}
                setSelected={setSelectedManagements}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Salir
          </CustomButton>
        </DialogActions>
      </Dialog>
      <ConfirmAndExecuteDialog
        open={!!confirmDialogOpen}
        title={confirmDialogTitle}
        description={confirmDialogDescription}
        onConfirm={confirmAction}
        onCancel={() => setConfirmDialogOpen(false)}
        setOpen={setConfirmDialogOpen}
        buttonColor={buttonColor}
      />
      {openEditManagement && (
        <EditManagement
          openEditManagementId={openEditManagementId}
          open={openEditManagement}
          setOpen={setOpenEditManagement}
          setDescription={setDescription}
          description={description}
          possiblePaymentDate={possiblePaymentDate}
          setPossiblePaymentDate={setPossiblePaymentDate}
          setConfirmDialogTitle={setConfirmDialogTitle}
          setConfirmDialogDescription={setConfirmDialogDescription}
          setConfirmAction={setConfirmAction}
          setButtonColor={setButtonColor}
          setConfirmDialogOpen={setConfirmDialogOpen}
        />
      )}
      {rescheduleManagementOpen && (
        <RescheduleManagement
          open={rescheduleManagementOpen}
          setOpen={setRescheduleManagementOpen}
          openEditManagementId={openEditManagementId}
          dueDate={dueDate}
          setDueDate={setDueDate}
          setConfirmDialogTitle={setConfirmDialogTitle}
          setConfirmDialogDescription={setConfirmDialogDescription}
          setConfirmAction={setConfirmAction}
          setButtonColor={setButtonColor}
          setConfirmDialogOpen={setConfirmDialogOpen}
        />
      )}
      {openMultiComplete && (
        <MultiComplete
          open={openMultiComplete}
          setOpen={setOpenMultiComplete}
          managementsToComplete={managementsToComplete}
          byStakeholder={byStakeholder}
          handleOpenCreateNewManagementFromCompletion={
            handleOpenCreateNewManagementFromCompletion
          }
          handleOpenCreateNewMultiManagementFromCompletion={
            handleOpenCreateNewMultiManagementFromCompletion
          }
          reloadPage={reloadPage}
        />
      )}
      {openMultiDelete && (
        <MultiDelete
          open={openMultiDelete}
          setOpen={setOpenMultiDelete}
          managementsToDelete={managementsToDelete}
        />
      )}
      {openMultiReschedule && (
        <MultiReschedule
          open={openMultiReschedule}
          setOpen={setOpenMultiReschedule}
          managementsToReschedule={managementsToReschedule}
          byStakeholder={byStakeholder}
        />
      )}
    </div>
  );
};

export default ManagementsDetails;
